/* istanbul ignore file */
import { Button as MaterialButton } from '@mui/material';
import { styled } from '@mui/material/styles';

import { px, rem, Theme } from '../../theme';

import { StyledButtonProperties } from './PinoButton.types';

const StyledMaterialButton = styled(MaterialButton)<StyledButtonProperties>`
    ${({ theme }: { theme: Theme }) => theme.typography.text_19_bold};
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing([rem(0.55), rem(3)], [2, 7.5])};
        text-align: center;
        text-transform: uppercase;
        border-radius: ${theme.tggSpacing(rem(3.2), 13)};
	`}
`;

export const StyledPinoButton = styled(StyledMaterialButton, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<StyledButtonProperties>`
    ${({ theme }: { theme: Theme }) => theme.typography.text_12_desktop_14}
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing([rem(0.1), rem(1)], [1, 6])};
        font-weight: 500;
        text-transform: lowercase;
        color: ${theme.palette.common.blue};
        background-color: ${theme.palette.common.white};
        border: ${theme.tggSpacing(px(1), 0.25)} solid;
        border-radius: ${theme.tggSpacing(rem(3.2), 13)};
    `}

    ${({ disabled }: StyledButtonProperties) =>
        disabled &&
        `
            opacity: 0.5;
            cursor: not-allowed;
        `} 

    ${({ selected, $buttonLocation: variant, theme }: StyledButtonProperties) =>
        selected &&
        variant === 'card' &&
        `
            background-color: ${theme.palette.common.blue};
            border-color: ${theme.palette.common.blue};
    `}

    ${({ selected, $buttonLocation: variant, theme }) =>
        selected &&
        variant !== 'card' &&
        `
            border-color: ${theme.palette.common.white};
    `}

    &:focus {
        ${({ theme }: { theme: Theme }) => `
            outline: ${theme.tggSpacing(rem(0.25), 0.625)}
                solid ${theme.palette.common.white};
            outline-offset: ${theme.tggSpacing(rem(0.25), 0.625)};
        `}
    }

    &:hover {
        ${({
            selected,
            $buttonLocation: variant,
            theme,
        }: StyledButtonProperties) => {
            if (selected && variant === 'card') {
                return `
                    background-color: ${theme.palette.common.blue};
                    border-color: ${theme.palette.common.blue};
                `;
            }
            if (selected) {
                return `
                    background-color: ${theme.palette.common.white};
                `;
            }
            if (!selected) {
                return `
                    background-color: ${theme.palette.common.blue};
                    color: ${theme.palette.common.white};
                    border: 1px solid transparent;
                `;
            }
            return '';
        }}
    }
`;
